<template>
    <transition name="modal-fade">
        <div class="modal__backdrop" v-show="open" @click="close">
            <div @click.stop class="modal__container" :class="{ 'modal__container--card': isCard,  'modal__container--max-width': removePadding, ...modalTypeStyles, 'modal__container--width-auto': widthAuto  }">
                <slot name="image"></slot>

                <div class="modal__content modal__banner" v-if="showBanner">
                    <slot name="banner"></slot>
                </div>

                <div v-if="enableInner" class="modal__inner" :class="{'modal__inner--narrow': narrow, 'modal__inner--remove-padding': removePadding}" ref="scrollableArea">
                    <div class="modal__content modal__header" v-if="showHeader">
                        <slot name="header"></slot>
                    </div>

                    <div class="modal__content modal__body" :class="{'modal__content--vertical': verticalContent}" v-if="showBody">
                        <slot name="body"></slot>
                    </div>

                    <slot></slot>

                    <div class="modal__content modal__buttons" v-if="showButtons">
                        <slot name="buttons"></slot>
                    </div>

                    <div class="modal__content modal__footer" v-if="showFooter">
                        <slot name="footer"></slot>
                    </div>

                    <img v-if="showCloseIcon && closeInInner" src="/images/used/close-icon.svg" :class="{'modal__close-icon': true, 'modal__close-icon--background': closeHasBackground}" alt="Close" @click="dismissModal" />
                </div>

                <img v-if="showCloseIcon && (!closeInInner || !enableInner)" src="/images/used/close-icon.svg" :class="{'modal__close-icon': true, 'modal__close-icon--background': closeHasBackground}" alt="Close" @click="dismissModal" />
            </div>
        </div>
    </transition>
</template>

<script>
const bodyScrollLock = require('body-scroll-lock');

export default {
    props: {
        open: {
            type: Boolean,
            required: true,
            default: false
        },
        narrow: {
            type: Boolean,
            required: false,
            default: true
        },
        verticalContent: {
            type: Boolean,
            required: false,
            default: false
        },
        isCard: {
            type: Boolean,
            required: false,
            default: false
        },
        isDismissedOnClickBackdrop: {
            type: Boolean,
            required: false,
            default: true
        },
        borderTop: {
            type: Boolean,
            required: false,
            default: true
        },
        showCloseIcon: {
            type: Boolean,
            required: false,
            default: false
        },
        closeInInner: {
            type: Boolean,
            required: false,
            default: false
        },
        closeHasBackground: {
            type: Boolean,
            required: false,
            default: false
        },
        removePadding: {
            type: Boolean,
            required: false,
            default: false
        },
        widthAuto: {
            type: Boolean,
            required: false,
            default: false
        },
        enableInner: {
            type: Boolean,
            required: false,
            default: true,
        },
        modalType: {
            type: String,
            required: false,
            default: '',
        }
    },
    data() {
        return {
            showHeader: false,
            showBody: false,
            showButtons: false,
            showFooter: false,
            showBanner: false
        }
    },
    watch: {
        open: {
            deep: false,
            immediate: true,
            handler: function (newValue) {
                if (newValue == true) {
                    this.$nextTick(() => {
                        this.setShowSlots();
                    });
                    bodyScrollLock.disableBodyScroll(this.$refs['scrollableArea']);
                    return;
                }
                if (this.$refs['scrollableArea']) {
                    bodyScrollLock.enableBodyScroll(this.$refs['scrollableArea']);
                }
            },
        }
    },
    computed: {
        modalTypeStyles(){
            return {
                'modal__container--login-modal': this.modalType === 'loginModal',
                'modal__container--saved-vehicle': this.modalType === 'savedVehicle',
                'modal__container--price-alert': this.modalType === 'priceAlert'
            }
        }
    },
    methods: {
        close() {
            if (this.isDismissedOnClickBackdrop === true) {
                this.$emit('close');
            }
        },
        dismissModal() {
            this.$emit('close');
        },
        setShowSlots() {
            this.showBanner = this.$slots.banner?.[0]
            this.showHeader = this.$slots.header?.[0]
            this.showBody = this.$slots.body?.[0]
            this.showButtons = this.$slots.buttons?.[0]
            this.showFooter = this.$slots.footer?.[0]
        }
    },
    mounted(){
        this.setShowSlots();
    },
    created() {
        this.setShowSlots();
    },
    beforeUpdate() {
        this.setShowSlots();
    },
    beforeDestroy() {
        bodyScrollLock.enableBodyScroll(this.$refs['scrollableArea']);
    }
}
</script>
